export function HelperInfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="0.9rem"
      height="0.9rem"
      viewBox="-1 -1 15 15"
      fill="none"
      style={{ display: "block", margin: 0, width: "0.9rem", height: "0.9rem", flexShrink: 0, overflow: "visible" }}
      aria-hidden="true"
    >
      <path
        d="M6.5 1.21875C9.4174 1.21875 11.7812 3.58262 11.7812 6.5C11.7812 9.4174 9.4174 11.7812 6.5 11.7812C3.58262 11.7812 1.21875 9.4174 1.21875 6.5C1.21875 3.58262 3.58262 1.21875 6.5 1.21875ZM6.5 13C10.0902 13 13 10.0902 13 6.5C13 2.90977 10.0902 0 6.5 0C2.90977 0 0 2.90977 0 6.5C0 10.0902 2.90977 13 6.5 13ZM5.48438 8.5313C5.14668 8.5313 4.875 8.8029 4.875 9.1406C4.875 9.4783 5.14668 9.75 5.48438 9.75H7.51562C7.85332 9.75 8.125 9.4783 8.125 9.1406C8.125 8.8029 7.85332 8.5313 7.51562 8.5313H7.3125V6.29688C7.3125 5.95918 7.04082 5.6875 6.70312 5.6875H5.48438C5.14668 5.6875 4.875 5.95918 4.875 6.29688C4.875 6.63457 5.14668 6.90625 5.48438 6.90625H6.09375V8.5313H5.48438ZM6.5 4.875C6.94941 4.875 7.3125 4.51191 7.3125 4.0625C7.3125 3.61309 6.94941 3.25 6.5 3.25C6.05059 3.25 5.6875 3.61309 5.6875 4.0625C5.6875 4.51191 6.05059 4.875 6.5 4.875Z"
        fill="var(--neutral-default, #5E5E5E)"
      />
    </svg>
  );
}
